import React from 'react';
import { FormattedMessage } from 'react-intl';
import { CountySelectFragment } from './county-select.graphql';

import Select from 'four-nets/ui-v2/select/select';

export interface Props extends React.SelectHTMLAttributes<HTMLSelectElement>, CountySelectFragment {
    errors?: React.ReactNode[];
}

export const ABROAD_COUNTY = 'abroad';

class CountySelect extends React.PureComponent<Props> {
    render() {
        const { edges, ...rest } = this.props;

        return (
            <Select {...rest}>
                {[...edges].sort((a, b) => {
                    if (a?.node?.name.includes('Celá') || a?.node?.name.includes('Celé')) {
                        return -1;
                    }
                    return 1
                }).map(edge => {
                    if (edge && edge.node) {
                        const { name, id } = edge.node;
                        return (
                            <option key={id} value={id}>
                                {name}
                            </option>
                        );
                    }

                    return null;
                })}
                <FormattedMessage id='ABROAD_COUNTIES'>
                    {message => <option value={ABROAD_COUNTY}>{message}</option>}
                </FormattedMessage>
            </Select>
        );
    }
}

export default CountySelect;
